// @ts-check

import {
    calculateMortgageBalance,
    calculateMortgagePayment,
    getPaymentsMadeAfterYears
  } from "../../utils/mortgageCalculations";
  import { round2 } from "./validators";
  
  /**
   * Solde hypothécaire après X années.
   */
  export function mortgageBalanceAfterYears({
    principal,
    ratePct,
    amortizationYears,
    yearsElapsed,
    paymentFrequency = "monthly"
  }) {
    const paymentsMade = getPaymentsMadeAfterYears(yearsElapsed, paymentFrequency);
    return round2(
      calculateMortgageBalance(principal, ratePct, amortizationYears, paymentFrequency, paymentsMade)
    );
  }
  
  /**
   * Service de dette annuel (MVP: mensualités * 12)
   */
  export function annualDebtService({
    principal,
    ratePct,
    amortizationYears,
    paymentFrequency = "monthly"
  }) {
    const calc = calculateMortgagePayment(principal, ratePct, amortizationYears, paymentFrequency);
    // MVP: monthly only
    return round2(calc.periodicPayment * 12);
  }
  